module.exports = __webpack_public_path__ + "b5e67d80f0fe61a11ce0b138b10ce0b5.svg";